import React from 'react';
import { 
  Card, 
  CardHeader, 
  CardContent, 
  Typography, 
  Box 
} from '@mui/material';
import CustomDate from "../../components/CustomForm/CustomDate";
import {
  ethnicityOptions,
  genderOptions,
  maritalStatus,
  religionOptions,
  titleOptions,
} from "../../components/Clients/client.config";
import CustomInput from "../../components/FormFields/CustomInput";
import CustomSelect from "../../components/FormFields/CustomSelect/CustomSelect";

const PersonalDetails = ({ handleChange, data, setFormData }) => {
  const handleLocalChange = (event) => {
    const { name, value } = event.target;
    if (handleChange) {
      handleChange(event);
    }
  };

  const titleOptionsFormatted = titleOptions?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  const maritalStatusOptions = maritalStatus?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  const genderOptionsFormatted = genderOptions?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  const religionOptionsFormatted = religionOptions?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  const ethnicityOptionsFormatted = ethnicityOptions?.map((opt) => ({
    value: opt.value || opt,
    label: opt.label || opt,
  })) || [];

  return (
    <Box sx={{ width: '100%', mb: 1 }}>
      <Card variant="outlined" sx={{ borderRadius: 2, border: '1px solid #E4E7EC' }}>
        <CardHeader
          title={
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1570EF' }}>
              Personal Details
            </Typography>
          }
          sx={{ 
            backgroundColor: '#F9FAFB',
            borderBottom: '1px solid #EAECF0',
            py: 0.75,
            px: 2
          }}
        />
        <CardContent sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="first_name"
                label="First Name *"
                value={data?.first_name || ""}
                onChange={handleLocalChange}
                required
                fullWidth
                size="small"
                placeholder="e.g., John"
              />
            </Box>
            
            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="middle_name"
                label="Middle Name"
                value={data?.middle_name || ""}
                onChange={handleLocalChange}
                fullWidth
                size="small"
                placeholder="e.g., William"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="last_name"
                label="Last Name *"
                value={data?.last_name || ""}
                onChange={handleLocalChange}
                required
                fullWidth
                size="small"
                placeholder="e.g., Smith"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomSelect
                options={titleOptionsFormatted}
                value={data?.title || ""}
                onChange={handleLocalChange}
                placeholder="e.g., Mr"
                fullWidth
                size="small"
                name="title"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="suffix_name"
                label="Suffix"
                value={data?.suffix_name || ""}
                onChange={handleLocalChange}
                fullWidth
                size="small"
                placeholder="e.g., Jr, Sr"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="maiden_name"
                label="Maiden Name"
                value={data?.maiden_name || ""}
                onChange={handleLocalChange}
                fullWidth
                size="small"
                placeholder="e.g., Johnson"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomInput
                name="preferred_name"
                label="Preferred Name"
                value={data?.preferred_name || ""}
                onChange={handleLocalChange}
                fullWidth
                size="small"
                placeholder="e.g., Johnny"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomDate
                label="Date of Birth *"
                name="birthdate"
                value={data?.birthdate || ""}
                onChange={handleLocalChange}
                fullWidth
                size="small"
                placeholder="e.g., 15/03/1985"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomSelect
                options={maritalStatusOptions}
                value={data?.marital_status || ""}
                onChange={handleLocalChange}
                placeholder="e.g., Married"
                fullWidth
                size="small"
                name="marital_status"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomSelect
                options={genderOptionsFormatted}
                value={data?.gender || ""}
                onChange={handleLocalChange}
                placeholder="e.g., Male"
                fullWidth
                size="small"
                name="gender"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomSelect
                options={religionOptionsFormatted}
                value={data?.religion || ""}
                onChange={handleLocalChange}
                placeholder="e.g., Christian"
                fullWidth
                size="small"
                name="religion"
              />
            </Box>

            <Box sx={{ flex: '1 1 calc(25% - 12px)', minWidth: '200px' }}>
              <CustomSelect
                options={ethnicityOptionsFormatted}
                value={data?.ethnicity || ""}
                onChange={handleLocalChange}
                placeholder="e.g., White British"
                fullWidth
                size="small"
                name="ethnicity"
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PersonalDetails;